// Tech chips gliding along an arc, like a carousel.
// - Chips move steadily right to left and wrap around off-screen.
// - The chip in the middle grows and turns dark (spotlight); chips fade out at the edges.
// - Hovering the arc slows it down; it only runs while the About slide is on screen.
const SPEED = 38; // px per second along the arc
const HOVER_SPEED = 8;
const GAP_PER_CHIP = 1.28; // distance between chip centres, in chip widths

export default function initSkills() {
  const arc = document.querySelector(".arc");
  if (!arc) return;
  const slide = arc.closest(".slide");
  const chips = [...arc.querySelectorAll(".arc__ring li")];
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  let width = 0;
  let radius = 1500;
  let gap = 92;
  let offset = 0;
  let speed = SPEED;
  let target = SPEED;
  let last = 0;
  let raf = 0;
  let running = false;
  let focus = -1;

  function measure() {
    width = arc.clientWidth;
    const chip = chips[0].offsetWidth || 72;
    radius = Math.max(width * 1.25, 520);
    // the loop must be wider than the arc, so chips wrap where nobody sees them
    gap = Math.max(chip * GAP_PER_CHIP, (width + chip * 2) / chips.length);
    place();
  }

  function place() {
    const loop = gap * chips.length;
    let nearest = -1;
    let nearestDist = Infinity;
    chips.forEach((chip, i) => {
      // position along the arc, centred on 0
      let s = (((i * gap - offset) % loop) + loop) % loop;
      s -= loop / 2;
      const theta = s / radius;
      const x = Math.sin(theta) * radius;
      const y = (1 - Math.cos(theta)) * radius;
      const t = x / (width / 2); // -1 … 1 across the arc
      const scale = 1 + 0.32 * Math.exp(-((t * 2.4) ** 2));
      const fade = Math.min(1, Math.max(0, (1 - Math.abs(t)) * 4));
      chip.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
      chip.style.opacity = fade;
      if (Math.abs(x) < nearestDist) {
        nearestDist = Math.abs(x);
        nearest = i;
      }
    });
    if (nearest !== focus) {
      chips[focus]?.classList.remove("is-focus");
      chips[nearest].classList.add("is-focus");
      focus = nearest;
    }
  }

  function tick(time) {
    raf = requestAnimationFrame(tick);
    const dt = last ? Math.min((time - last) / 1000, 0.1) : 0;
    last = time;
    speed += (target - speed) * Math.min(1, dt * 4);
    offset += speed * dt;
    place();
  }

  function setRunning(on) {
    if (on === running || reduceMotion) return;
    running = on;
    if (on) {
      last = 0;
      raf = requestAnimationFrame(tick);
    } else {
      cancelAnimationFrame(raf);
    }
  }

  arc.addEventListener("pointerenter", () => (target = HOVER_SPEED));
  arc.addEventListener("pointerleave", () => (target = SPEED));

  const sync = () => setRunning(slide.classList.contains("is-active") && !document.hidden);
  document.addEventListener("slidechange", sync);
  document.addEventListener("visibilitychange", sync);
  window.addEventListener("resize", measure);
  measure();
}
